export type ScrumTiPointStatus = 'À valider' | 'À ajouter au scrum' | 'Archivé';

export type ScrumTiPoint = {
  id: string;
  title: string;
  details: string;
  owner: string;
  status: ScrumTiPointStatus;
  scrumDate: string;
  createdAt: string;
  updatedAt: string;
  archivedAt?: string;
};

export type ScrumTiDay = {
  id: string;
  date: string;
  title: string;
  pointIds: string[];
  createdAt: string;
  updatedAt: string;
};

export type ScrumTiState = {
  points: ScrumTiPoint[];
  scrums: ScrumTiDay[];
};

export type ScrumTiPayload = {
  state: ScrumTiState;
  updated_at?: string;
  updated_by_email?: string;
};

const API_URL = '/api/serq/scrum-ti/state';

export const emptyScrumTiState = (): ScrumTiState => ({
  points: [],
  scrums: [],
});

export async function getScrumTiState(): Promise<ScrumTiPayload> {
  const res = await fetch(API_URL, { credentials: 'include' });
  if (!res.ok) throw new Error('Erreur chargement Scrum-TI');
  const payload = await res.json();
  return {
    ...payload,
    state: normalizeScrumTiState(payload.state),
  };
}

export async function saveScrumTiState(state: ScrumTiState): Promise<ScrumTiPayload> {
  const res = await fetch(API_URL, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ state }),
  });
  if (!res.ok) throw new Error('Erreur sauvegarde Scrum-TI');
  const payload = await res.json();
  return {
    ...payload,
    state: normalizeScrumTiState(payload.state),
  };
}

function normalizeScrumTiState(raw: Partial<ScrumTiState> | null | undefined): ScrumTiState {
  const points = raw?.points;
  const scrums = raw?.scrums;
  return {
    points: Array.isArray(points) ? points : [],
    scrums: Array.isArray(scrums) ? scrums : [],
  };
}
